import styled from 'styled-components';

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  background-color: #333;
  color: #fff;
  padding: 15px;
`;

export const Paragraph = styled.p`
  margin: 0 0 7px;
  font-size: 14px;
  text-align: center;

  &:last-child {
    margin-bottom: 0;
  }
`;
